'use client';

import { PositionDirection } from '@velocity-exchange/sdk';
import { matchEnum, UIMarket } from '@velocity-exchange/common';
import type { ParentOrderInfo } from 'src/@types/historyTables';

interface ActionCellProps {
	order: ParentOrderInfo;
}

export function ActionCell({ order }: ActionCellProps) {
	const { direction, reduceOnly, marketIndex, marketType } = order;
	const uiMarket = new UIMarket(marketIndex, marketType);
	const isLong = matchEnum(direction, PositionDirection.LONG);

	const label =
		uiMarket.isPerp && !uiMarket.isPredictionMarket
			? reduceOnly
				? `Close ${isLong ? 'Short' : 'Long'}`
				: isLong
					? 'Long'
					: 'Short'
			: isLong
				? 'Buy'
				: 'Sell';

	return (
		<span
			className={
				isLong
					? 'text-text-positive-green-button'
					: 'text-text-negative-red-button'
			}
		>
			{label}
		</span>
	);
}
